export default {
    inquiry: 'Inquiry',
    inquiryInTd: 'Inquiry',
    name: 'Name',
    employeeNo: 'Employee No',
    approve: 'Approve',
    reject: 'Reject',
    inquiryMessage: 'There is no leave and onsite request of date ',
    mon: 'M',
    tues: 'T',
    wednes: 'W',
    thurs: 'TH',
    fri: 'F',
    satur: 'SA',
    sun: 'S',
    congratulation: 'Congratulation',
    applicationStatus: 'application status of',
    isUpdated: 'is updated'
}
